import { NavigationContainer } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { DarkTheme } from "@react-navigation/native";

import Home from "./screens/Home";
import ResearchAndDev from "./screens/ResearchAndDev/Index";
import CropResearch from "./screens/ResearchAndDev/CropResearch";
import SoilResearch from "./screens/ResearchAndDev/SoilResearch";
import NutrientMaps from "./screens/ResearchAndDev/NutrientMaps";
import HubMap from "./screens/Distribution/HubMap";

import FarmerCentricProjects from "./screens/FarmerCentricProjects/Index";
import Digital from "./screens/FarmerCentricProjects/Digital";
import FarmInitiatives from "./screens/FarmerCentricProjects/FarmInitiatives";
import Media from "./screens/FarmerCentricProjects/Media";
import Agribooster from "./screens/FarmerCentricProjects/Agribooster";

import Production from "./screens/Production/Production";
import ChemicalPlatform from "./screens/Production/ChemicalPlatform";
import BulkBlendingPlants from "./screens/Production/BulkBlendingPlants";
import SmartBlenders from "./screens/Production/SmartBlenders";

import Distribution from "./screens/Distribution/Distribution";

import { HStack, Menu, Pressable } from "native-base";
import { Image, useWindowDimensions } from "react-native";
import { StackParamList, StackScreenProps, MainStackParamList } from "./types";
import Agriprometers from "./screens/Distribution/Agriprometers";
import FFH from "./screens/Distribution/FFH";
import PublicPatnerships from "./screens/PublicPartnerships/PublicPartners";
import CSR from "./screens/PublicPartnerships/CSR";
import GovernmentPartnerships from "./screens/PublicPartnerships/GovernmentPartnerships";
import Team from "./screens/Team";
import Gallery from "./screens/Gallery";
import SchoolLab from "./screens/FarmerCentricProjects/SchoolLab";
import EMAY from "./screens/FarmerCentricProjects/Emay";
import ModelFarm from "./screens/FarmerCentricProjects/ModelFarm";
import FFtv from "./screens/FarmerCentricProjects/FFtv";
import FFradio from "./screens/FarmerCentricProjects/FFradio";
import Admin from "./screens/Admin";

const Stack = createNativeStackNavigator<MainStackParamList>();
const HomeStack = createNativeStackNavigator<StackParamList>();

export default function Navigation() {
  return (
    <NavigationContainer theme={DarkTheme}>
      <Stack.Navigator
        screenOptions={{
          headerShown: false,
          headerTransparent: true,
          headerShadowVisible: false,
          headerTitle: "",
        }}
      >
        <Stack.Screen name="Main" component={HomeNavigation} />
      </Stack.Navigator>
    </NavigationContainer>
  );
}

const HomeNavigation = ({ navigation }: StackScreenProps<"Home">) => {
  const { width } = useWindowDimensions();

  return (
    <HomeStack.Navigator
      screenOptions={{
        headerTransparent: true,
        headerShadowVisible: false,
        headerTitle: "",
        header: () => (
          <HStack
            w={width}
            justifyContent={"space-between"}
            alignItems={"center"}
            paddingY={7}
            paddingX={5}
          >
            <Pressable
              onPress={() => navigation.navigate("Home")}
              onLongPress={() => navigation.navigate("Admin")}
            >
              <Image
                source={require("./assets/logo.png")}
                style={{ width: 20, height: 30, marginLeft: 15 }}
              />
            </Pressable>

            <Menu
              w="130"
              mr="5"
              trigger={(triggerProps) => {
                return (
                  <Pressable
                    accessibilityLabel="More options menu"
                    {...triggerProps}
                  >
                    <Image
                      source={require("./assets/menu.png")}
                      style={{ width: 20, height: 20, marginRight: 15 }}
                    />
                  </Pressable>
                );
              }}
            >
              <Menu.Item onPress={() => navigation.navigate("ResearchAndDev")}>
                Research And Development
              </Menu.Item>
              <Menu.Item onPress={() => navigation.navigate("Distribution")}>
                Distribution
              </Menu.Item>
              <Menu.Item
                onPress={() => navigation.navigate("FarmerCentricProjects")}
              >
                Farmer-Centric Projects
              </Menu.Item>
              <Menu.Item
                onPress={() => navigation.navigate("PublicPartnerships")}
              >
                Partnerships
              </Menu.Item>
              <Menu.Item onPress={() => navigation.navigate("Production")}>
                Production
              </Menu.Item>
              <Menu.Item onPress={() => navigation.navigate("Gallery")}>
                Gallery
              </Menu.Item>
              <Menu.Item onPress={() => navigation.navigate("Team")}>
                Team
              </Menu.Item>
            </Menu>
          </HStack>
        ),

        animation: "slide_from_bottom",
      }}
    >
      <HomeStack.Screen name="Home" component={Home} />
      <HomeStack.Group>
        <HomeStack.Screen name="ResearchAndDev" component={ResearchAndDev} />
        <HomeStack.Screen name="CropResearch" component={CropResearch} />
        <HomeStack.Screen name="SoilResearch" component={SoilResearch} />
        <HomeStack.Screen name="NutrientMaps" component={NutrientMaps} />
      </HomeStack.Group>
      <HomeStack.Group>
        <HomeStack.Screen
          name="FarmerCentricProjects"
          component={FarmerCentricProjects}
        />
        <HomeStack.Screen name="Digital" component={Digital} />
        <HomeStack.Group>
          <HomeStack.Screen
            name="FarmInitiatives"
            component={FarmInitiatives}
          />
          <HomeStack.Screen name="AgriBooster" component={Agribooster} />
          <HomeStack.Screen name="SchoolLab" component={SchoolLab} />
          <HomeStack.Screen name="ModelFarm" component={ModelFarm} />
          <HomeStack.Screen name="EMAY" component={EMAY} />
        </HomeStack.Group>
        <HomeStack.Screen name="Media" component={Media} />
        <HomeStack.Screen name="FFtv" component={FFtv} />
        <HomeStack.Screen name="FFradio" component={FFradio} />
      </HomeStack.Group>

      <HomeStack.Group>
        <HomeStack.Screen name="Production" component={Production} />
        <HomeStack.Screen
          name="BulkBlendingPlants"
          component={BulkBlendingPlants}
        />
        <HomeStack.Screen
          name="ChemicalPlatform"
          component={ChemicalPlatform}
        />
        <HomeStack.Screen name="SmartBlenders" component={SmartBlenders} />
      </HomeStack.Group>

      <HomeStack.Group>
        <HomeStack.Screen name="Distribution" component={Distribution} />
        <HomeStack.Screen name="Agriprometers" component={Agriprometers} />
        <HomeStack.Screen name="FFH" component={FFH} />
        <HomeStack.Screen name="HubMap" component={HubMap} />
      </HomeStack.Group>

      <HomeStack.Group>
        <HomeStack.Screen
          name="PublicPartnerships"
          component={PublicPatnerships}
        />
        <HomeStack.Screen
          name="GovernmentPartnerships"
          component={GovernmentPartnerships}
        />
        <HomeStack.Screen name="CSR" component={CSR} />
      </HomeStack.Group>

      <HomeStack.Screen name="Team" component={Team} />
      <HomeStack.Screen name="Gallery" component={Gallery} />
      <HomeStack.Screen name="Admin" component={Admin} />
    </HomeStack.Navigator>
  );
};
